module.exports = "/1st/2026/packs/img_search_icon_c-290c5e013b39146a4cfa48acafc71257.png";